import type { PopoverProps } from "@mui/material";
import { Popover } from "@mui/material";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { AppButton } from "../../shared/components/AppButton";
import type { VersionPopoverInfo } from "../VersioningBlock/types";
import styles from "./styles.module.css";
import classNames from "classnames";

interface Props extends PopoverProps {
  children: ReactNode;
  handleClose?: () => void;
  onOk?: (id?: string | number, type?: string) => void;
  popoverInfo?: VersionPopoverInfo;
  className?: string;
  contentClassName?: string;
}

export const AppPopover = ({
  children,
  onOk,
  handleClose,
  popoverInfo,
  className,
  contentClassName,
  ...rest
}: Props) => {
  const { t } = useTranslation();
  const cls = classNames(styles.popover, className);
  const clsContent = classNames(styles["popover-content"], contentClassName);

  return (
    <Popover
      classes={{
        paper: cls,
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      {...rest}
    >
      <div className={clsContent}>
        {children}
        {(handleClose || onOk) && (
          <div className={styles["popover-button-wrapper"]}>
            {handleClose && (
              <AppButton
                buttonType={"outlined"}
                onClick={handleClose}
                className={styles["button"]}
              >
                {t("versioning.cancel_button_popover")}
              </AppButton>
            )}
            {onOk && (
              <AppButton
                buttonType={"contained"}
                onClick={() => onOk(popoverInfo?.id, popoverInfo?.type)}
                className={styles["button"]}
              >
                {t("versioning.confirm_button_popover")}
              </AppButton>
            )}
          </div>
        )}
      </div>
    </Popover>
  );
};
